import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";


function ChapterWisePYQCheTopics() {
  return (
    <>

      <AllSubjectTopics subject="chemistry" type="chapterwisepyq" />


    </>
  );
} 

export default ChapterWisePYQCheTopics;